import React from 'react';
import Helmet from 'react-helmet';

var Metadata = function Metadata(_ref) {
  var canonical = _ref.canonical,
      description = _ref.description,
      keywords = _ref.keywords,
      title = _ref.title,
      _ref$noIndex = _ref.noIndex,
      noIndex = _ref$noIndex === void 0 ? false : _ref$noIndex,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, title), keywords && /*#__PURE__*/React.createElement("meta", {
    name: "keywords",
    content: keywords
  }), description && /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: description
  }), noIndex && /*#__PURE__*/React.createElement("meta", {
    name: "robots",
    content: "noindex"
  }), canonical && /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: canonical
  }), children);
};

export default Metadata;